/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  FormControl,
  FormLabel,
  Select as SelectChakra,
  SelectProps,
  FormErrorMessage
} from '@chakra-ui/react'
import { FieldError } from 'react-hook-form'
import React, { forwardRef, ForwardRefRenderFunction } from 'react'

interface OptionsProps {
  value: string | number
  label: string
  disabled?: boolean
}
interface Props extends SelectProps {
  name: string
  label?: string
  errors?: any
  options: OptionsProps[]
  labelStyle?: any
  extraFunction?: (data?: any) => any
}

const BaseSelect: ForwardRefRenderFunction<HTMLSelectElement, Props> = (
  { name, label, errors = null, options, extraFunction, onChange, labelStyle, ...rest },
  ref
) => (
  <FormControl id={name} isInvalid={!(errors == null)}>
    {!!label && <FormLabel color="green.dark" style={labelStyle}>{label}</FormLabel>}
    <SelectChakra
      name={name}
      id={name}
      bg="white"
      variant="filled"
      border="1px"
      borderColor="blue.500"
      ref={ref}
      minHeight="48px"
      onChange={(e) => {
        onChange?.(e) // Chama o `onChange` do `register`, se existir
        extraFunction?.(e.target.value) // Chama a função extra
      }}
      {...rest}
    >
      {options.map((i: OptionsProps) => (
        <option key={i.value} value={i.value} disabled={i.disabled}>
          {i.label}
        </option>
      ))}
    </SelectChakra>
    {!(errors == null) && <FormErrorMessage>{errors.message}</FormErrorMessage>}
  </FormControl>

)

export const Select = forwardRef(BaseSelect)
